import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import { useMemo } from 'react';
/** import third-party libraries in the section above, keep the ascending order */

import { actions, REDUCER_KEY } from './redux';
import { getExportErrorMessagesAsCsv, getPendingJobCount, getUnSavedReports } from './selectors';
import reportEditorActions from 'pages/reports/editor/actions';
/** import classes and others in the section above, keep the ascending order */

export function useReportJobs() {
    const dispatch = useDispatch();
    const state = useSelector(state => state[REDUCER_KEY]);
    const boundActions = useMemo(() => bindActionCreators(actions, dispatch), [dispatch]);
    const { openEditor } = useMemo(() => bindActionCreators(reportEditorActions, dispatch), [
        dispatch,
    ]);
    const exportErrorMessage = useSelector(getExportErrorMessagesAsCsv);
    const pendingJobCount = useSelector(getPendingJobCount);
    const unSavedReports = useSelector(getUnSavedReports);

    return {
        ...state,
        ...boundActions,
        openEditor,
        exportErrorMessage,
        pendingJobCount,
        unSavedReports,
    };
}
